import {
  createBaseTheme,
  turquoise3,
  turquoise4,
  turquoise5,
  ultraDarkGray,
  ultraLightGray,
  white,
} from "shared-ts-mui";
import { lighten } from "@mui/material";

const background = "#191919";
const card = "#202020";
const input = "#333333";
const airmontTorqiseDark = "#669999";
const airmontTorqiseLight = "#9ACCCC";
const dark_secondary_container = "#3D5252";
const turquoiseHover = turquoise4;
export const darkTheme = createBaseTheme({
  cssVariables: true,
  palette: {
    mode: "dark",
    common: {
      black: background,
    },
    primary: {
      main: airmontTorqiseLight,
      light: card,
    },
    secondary: {
      main: airmontTorqiseDark,
      dark: airmontTorqiseLight,
      light: input,
    },
    background: {
      default: background,
      paper: background,
      card: card,
    },
    text: {
      primary: ultraLightGray,
    },
    input: {
      background: lighten(card, 0.02),
      hover: lighten(card, 0.02),
    },
    action: {
      selected: turquoise3,
      //selectedText: white,
      hover: turquoiseHover,
      hoverOpacity: 0.2,
    },
    actionGroup: {
      //standard farge
      primary: ultraDarkGray,
      primaryText: ultraDarkGray,
      selected: turquoise5, //darken(airmontTurquoise, 0.3),
      selectedText: white,
      hover: turquoiseHover,
      hoverText: white,
    },
  },
});
